import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { environment } from 'environments/environment';

// Create axios instance
const api: AxiosInstance = axios.create({
    baseURL: `${environment.APP_HOST}/site`,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add auth token and handle FormData
api.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        const token = localStorage.getItem('accessToken');
        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        // When sending FormData, remove Content-Type so browser sets multipart/form-data with boundary
        if (config.data instanceof FormData && config.headers) {
            delete config.headers['Content-Type'];
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Handle unauthorized
            localStorage.removeItem('accessToken');
            localStorage.removeItem('userDetail');
            localStorage.removeItem('userType');
            window.location.hash = '/sign-in';
        }
        return Promise.reject(error);
    }
);

export default api;
